"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _modal = _interopRequireDefault(require("../../../core/modal"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _indexModule = _interopRequireDefault(require("../../../static/styles/index.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const cx = _bind.default.bind(_indexModule.default);

const util = require('capsule-core-js/dist/util');

class SelectWallet extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "net", () => {
      let net = util.getNetworkId(window.kambriaWallet.networkId.ethereum, 'string');
      let Net = net.charAt(0).toUpperCase() + net.slice(1);
      return /*#__PURE__*/_react.default.createElement("span", {
        className: cx("network", "ethereum")
      }, Net, " Network");
    });

    _defineProperty(this, "onMetamask", () => {
      this.done(null, {
        type: 'softwallet',
        wallet: 'metamask',
        model: 'metamask'
      });
    });

    _defineProperty(this, "onHardwallet", () => {
      this.done(null, {
        type: 'hardwallet'
      });
    });

    _defineProperty(this, "onHybridwallet", () => {
      this.done(null, {
        type: 'hybridwallet'
      });
    });

    _defineProperty(this, "onSoftwallet", () => {
      this.done(null, {
        type: 'softwallet',
        wallet: 'isoxys'
      });
    });

    this.done = props.done;
    this.onClose = props.onClose;
  }

  render() {
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      visible: true,
      className: cx("fade", "wallet-modal", "choose-wallet"),
      dialogClassName: cx("modal-dialog-centered")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: cx("modal-body")
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: cx("close-button"),
      onClick: this.onClose
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: cx("title", "d-block", "text-center", "my-4")
    }, "Choose Your Wallet"), this.net(), /*#__PURE__*/_react.default.createElement("div", {
      className: cx("wallets")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: cx("wallet", "metamask")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: cx("icon")
    }), /*#__PURE__*/_react.default.createElement("button", {
      className: cx("btn", "btn-gray", "btn-sm"),
      onClick: this.onMetamask
    }, "Metamask")), /*#__PURE__*/_react.default.createElement("div", {
      className: cx("wallet", "hardware")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: cx("icon")
    }), /*#__PURE__*/_react.default.createElement("button", {
      className: cx("btn", "btn-gray", "btn-sm"),
      onClick: this.onHardwallet
    }, "Hardware Wallet")), /*#__PURE__*/_react.default.createElement("div", {
      className: cx("wallet", "hybrid")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: cx("icon")
    }), /*#__PURE__*/_react.default.createElement("button", {
      className: cx("btn", "btn-gray", "btn-sm"),
      onClick: this.onHybridwallet
    }, "Hybrid Wallet")), /*#__PURE__*/_react.default.createElement("div", {
      className: cx("wallet", "software")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: cx("icon")
    }), /*#__PURE__*/_react.default.createElement("button", {
      className: cx("btn", "btn-gray", "btn-sm"),
      onClick: this.onSoftwallet
    }, "Software Wallet")))));
  }

}

var _default = SelectWallet;
exports.default = _default;